import { useCallback, useEffect, useState } from 'react';

import { fetch_close_versions_summary } from '../api';

/*
 * PROD-7828 D111 — the month's close versions summary, read once by the shell: it badges the tab and
 * the tab reads its counts and default mode from it. Re-read when the month changes, when `rev` moves
 * (the shell's meta_rev: a close, reopen or recalculation) or on reload() (Try again).
 * Returns {status: 'idle'|'loading'|'ready'|'error', data, error, reload}.
 */
const initial = (pay_month) => ({
  month: pay_month,
  status: pay_month ? 'loading' : 'idle',
  data: null,
  error: null
});

export const useCloseVersionsSummary = (pay_month, rev) => {
  const [state, setState] = useState(() => initial(pay_month));
  const [own_rev, setOwnRev] = useState(0);

  useEffect(() => {
    if (!pay_month) {
      setState(initial(''));
      return undefined;
    }
    let cancelled = false;
    // A re-read of the same month keeps its figures on screen; a failed one shows loading on retry.
    setState((s) => (s.month === pay_month && s.data ? s : initial(pay_month)));
    fetch_close_versions_summary(pay_month)
      .then((data) => {
        if (!cancelled) setState({ month: pay_month, status: 'ready', data, error: null });
      })
      .catch((error) => {
        if (cancelled) return;
        setState((s) => ({
          month: pay_month,
          status: 'error',
          data: s.month === pay_month ? s.data : null,
          error
        }));
      });
    return () => {
      cancelled = true;
    };
  }, [pay_month, rev, own_rev]);

  const reload = useCallback(() => setOwnRev((r) => r + 1), []);
  // Until the effect runs for a new month, the old month's figures are never handed out.
  const current = state.month === pay_month ? state : initial(pay_month);
  return { status: current.status, data: current.data, error: current.error, reload };
};
